import { requestConstantsMaker } from '../helper';

/**** 20200217 ****/
export const GET_ALL_STUDENT_ASQ = requestConstantsMaker('GET_ALL_STUDENT_ASQ');
export const GET_STUDENT_ASQ = requestConstantsMaker('GET_STUDENT_ASQ');
export const CREATE_STUDENT_ASQ = requestConstantsMaker('CREATE_STUDENT_ASQ');
export const UPDATE_STUDENT_ASQ = requestConstantsMaker('UPDATE_STUDENT_ASQ');
export const DELETE_STUDENT_ASQ = requestConstantsMaker('DELETE_STUDENT_ASQ');
export const GET_STUDENT_ASQS_FOR_SELECTION = requestConstantsMaker('GET_STUDENT_ASQS_FOR_SELECTION');
export const GET_STUDENT_ASQS_FOR_STUDENT_DETAIL = requestConstantsMaker('GET_STUDENT_ASQS_FOR_STUDENT_DETAIL');
/**** 20200217 ****/

export const GET_ALL_STUDENT_ASQ_BY_SPECIFICATION = requestConstantsMaker('GET_ALL_STUDENT_ASQ_BY_SPECIFICATION');
export const GET_STUDENT_ASQ_BY_ID = requestConstantsMaker('GET_STUDENT_ASQ_BY_ID');
export const GET_ACTIVE_STUDENT_ASQ_BY_STUDENT_ID = requestConstantsMaker('GET_ACTIVE_STUDENT_ASQ_BY_STUDENT_ID');
export const GET_ALL_STUDENT_ASQ_REMINDER = requestConstantsMaker('GET_ALL_STUDENT_ASQ_REMINDER');
export const POST_CREATE_STUDENT_ASQ = requestConstantsMaker('POST_CREATE_STUDENT_ASQ');
export const PUT_UPDATE_STUDENT_ASQ = requestConstantsMaker('PUT_UPDATE_STUDENT_ASQ');
